"use client"

import SearchIcon from "@/components/icons/SearchIcon";
import { storeRef } from "@/components/providers/StoreProvider";
import { useTERouter } from "@/hooks/app/useTERouter";
import { hotelActions } from "@/lib/redux/features/hotel/reduce";
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { getHotels } from "@/utils/hotel/getHotels";
import { getQueryStringSearchHotel } from "@/utils/hotel/getQueryStringSearchHotel";
import { Button } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

type ButtonSearchHotelsProps = {
  size?: 'small' | 'default'
}

const ButtonSearchHotels: FC<ButtonSearchHotelsProps> = ({ size }) => {
  const isSmall = size === 'small'
  const router = useTERouter()
  const loading = useAppSelector(state => state.hotel.hotels_search.loading)
  const dispatch = useAppDispatch()
  const { t, i18n } = useTranslation()
  return (
    <Button
      // Avoid loading-class SSR/CSR mismatch on first paint of results form.
      loading={loading || false}
      type="primary"
      size={isSmall ? "middle" : "large"}
      className={isSmall ? "home__searching--hero-search-btn" : "home__searching--button-search"}
      icon={<SearchIcon style={{ fontSize: isSmall ? '1.6rem' : '3rem' }} />}
      block={!isSmall}
      aria-label={t("hotel.search_hotels")}
      onClick={async () => {
        const hotelState = storeRef.current?.getState().hotel
        dispatch(hotelActions.selectCurrentDestination(hotelState?.formSearch?.location))
        const search = getQueryStringSearchHotel()
        toast.dismiss()
        if (!hotelState?.formSearch?.location?._id) {
          setTimeout(() => {
            toast.error(t("hotel.required_location_warning"), { position: "top-right" })
          }, 600)
          return
        };
        getHotels({
          page: 0,
          pageSize: 20,
          locale: i18n.language
        })
        router.push(`/hotels/result?${search}`)
      }}
    >
      {isSmall ? null : t("hotel.search_hotels")}
    </Button>
  );
}

export default ButtonSearchHotels;